import O1HD from "../../../../engines/gameEngine";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;
/**
 * 农场Node
 */
@ccclass
export default class FarmNode extends cc.Component {

    onLoad () {}

    start () {

    }

    /**
     * 鸡舍
     */
    async onBtnChickenCoop(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        if ( !NormalGameManager._instance.getGameData().hasBreedCooperativeData ||
             NormalGameManager._instance.getGameData().hasBreedCooperativeData.includes(1) == false ) {
            O1HD.getModules().uiControlModule.showMessageBox("请先在合作社办理养殖证");
            return ;
        }

        O1HD.getManagers().soundMgr.stopMusic();
        let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.chickenBundle, "prefab/chickenNode" );
        let chickenNode = cc.instantiate( prefab );
        O1HD.Canvas().addChild( chickenNode );
        // this._close();
    }

    /**
     * 菜地
     */
    async onBtnCd(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let url = "sitePrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.siteGameBundle,url);
        let sitePrefabNode = cc.instantiate( prefab );
        O1HD.Canvas().addChild( sitePrefabNode );
        // this._close();
    }

    /**
     *
     */
    onBtnBack(){
       O1HD.getManagers().soundMgr.playSound("anNiu").then();
       this._close();
    }

    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal","cd");
    }
}
